<div class="module drop-shadow bottom summary__module three">
  <div class="module--main third">
    <div class="block-num text-center">
      <svg class="ic"><use xlink:href="#ic-issues-col" href="#ic-issues-col"></use></svg>
      <h2 class="subheading-sm">Total issues</h2>
      <span class="lg">{{numberOfIssues}}</span>
    </div>
  </div>
  <div class="module--main third">
    <div class="block-num text-center">
      <svg class="ic"><use xlink:href="#ic-consumers" href="#ic-consumers"></use></svg>
      <h2 class="subheading-sm">Total consumers affected</h2>
      <span class="lg">{{numberOfConsumerWithIssues}}</span>
    </div>
  </div>
  <div class="module--main third">
    <div class="block-num text-center">
      <svg class="ic"><use xlink:href="#ic-multiple-issues" href="#ic-multiple-issues"></use></svg>
      <h2 class="subheading-sm">Change from last calendar month</h2>
      <span class="lg">
          {{issuesVariation}}
          <svg *ngIf="isIncreasing" class="ic-arrow"><use xlink:href="#ic-arrow-up-neg" href="#ic-arrow-up-neg"></use></svg>
          <svg *ngIf="isDecreasing" class="ic-arrow"><use xlink:href="#ic-arrow-down-pos" href="#ic-arrow-down-pos"></use></svg>
      </span>
    </div>
  </div>
</div>
